import React from 'react';
import { Container, Typography } from '@mui/material';

const Reports: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Reports
            </Typography>
            <Typography>
                View analytics and insights about your website revival campaigns.
            </Typography>
        </Container>
    );
};

export default Reports; 